/**
 * @generated SignedSource<<de8831b6a7d363cd2acc2f84428e80d5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type StatusColumnHeader_view$data = {
  readonly canInlineEditStatusColumns: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"BoardHeaderDropdown_view">;
  readonly " $fragmentType": "StatusColumnHeader_view";
};
export type StatusColumnHeader_view$key = {
  readonly " $data"?: StatusColumnHeader_view$data;
  readonly " $fragmentSpreads": FragmentRefs<"StatusColumnHeader_view">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "StatusColumnHeader_view",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "BoardHeaderDropdown_view"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "canInlineEditStatusColumns"
      },
      "action": "THROW",
      "path": "canInlineEditStatusColumns"
    }
  ],
  "type": "JiraBoardView"
};

(node as any).hash = "248cb49ea4f6b5273b55353b99c01248";

export default node;
